import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

interface StatusData {
  expiryDate: string;
  isExpired: boolean;
  maintenanceMode: boolean;
  maintenanceMessage: string;
  allowUploads: boolean;
  galleryTitle: string;
  gallerySubtitle: string;
  albumName: string;
  privacyNotice: string;
}

export function useStatus() {
  const [status, setStatus] = useState<StatusData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setError(null);
      const data = await api.status();
      setStatus(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler beim Laden des Status');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    ...status,
    isLoading,
    error,
    refresh: load,
  } as StatusData & { isLoading: boolean; error: string | null; refresh: () => Promise<void> };
}